module.exports = __webpack_public_path__ + "img/NaturalDisasterCritical.2822fd82.svg";